import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';

import { CreateDiscussionEffects } from './effects/create-discussion.effects';
import { DiscussionAnalyticsEffects } from './effects/discussion-analytics.effects';
import { DiscussionFormEffects } from './effects/discussion-form.effects';
import { DiscussionListEffects } from './effects/discussion-list.effects';
import { formReducer, FormState, InitialFormState } from './reducers/discussion-form.reducers';
import { InitialListState, listReducer, ListState } from './reducers/list.reducers';

export const DiscussionFeatureStateKey = 'page-discussion';

export interface DiscussionFeatureState {
  list: ListState;
  form: FormState;
}

const reducers: ActionReducerMap<DiscussionFeatureState> = {
  list: listReducer,
  form: formReducer,
};

export const InitialDiscussionFeatureState: DiscussionFeatureState = {
  list: InitialListState,
  form: InitialFormState,
};

@NgModule({
  imports: [
    StoreModule.forFeature(DiscussionFeatureStateKey, reducers),
    EffectsModule.forFeature([
      CreateDiscussionEffects,
      DiscussionListEffects,
      DiscussionFormEffects,
      DiscussionAnalyticsEffects,
    ]),
  ],
})
export class DiscussionStateModule {}
